<template>
  <b-form autocomplete="off">
    <b-alert :show="isErrors" variant="danger">
      {{ translations[2016] }}
    </b-alert>
    <b-form-group class="mb-2" label-for="consultant-username">
      <b-form-input
        autocomplete="off"
        size="lg"
        class="border-0"
        id="consultant-username"
        v-model="login.username"
        type="text"
        :placeholder="translations[227]"
        required
      ></b-form-input>
    </b-form-group>
    <b-input-group class="mb-2" label-for="consultant-password">
      <b-form-input
        autocomplete="off"
        size="lg"
        class="border-0"
        id="consultant-password"
        v-model="login.password"
        :type="passwordFieldType"
        :placeholder="translations[228]"
        required
      ></b-form-input>
      <b-input-group-append>
        <b-button variant="custom-light"  @click="togglePasswordVisibility">
          <b-icon :icon="passwordFieldIcon"></b-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <p class="fs-6 m-0 mt-2">
      <button type="button" v-b-modal.consultant-reset-password class="btn-inline-link text-aba-primary-800" @click="$emit('close')">{{ translations[10945] }}</button>
    </p>
  </b-form>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';

@Component
export default class LoginConsultantForm extends Vue {
  isPasswordVisible = false;

  get translations() {
    return AppModule.translation;
  }

  get sid() {
    return AppModule.sid;
  }

  get lang() {
    return AppModule.language;
  }

  // TokenApplicant
  get accessTokenApplicant() {
    return UserModule.accessTokenApplicant;
  }

  // TokenCompany
  get accessTokenCompany() {
    return UserModule.accessTokenCompany;
  }

  get isRedirectToCabinet() {
    return UserModule.isRedirectToCabinet;
  }

  get passwordFieldType() {
    return this.isPasswordVisible ? 'text' : 'password';
  }

  get passwordFieldIcon() {
    return this.isPasswordVisible ? 'eye-slash' : 'eye';
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  isErrors = false;

  login = {
    username: '',
    password: '',
    sid: this.sid,
  };

  async onLogin() {
    try {
      if (this.accessTokenApplicant) {
        UserModule.LogOutApplicant(this.sid);
      }

      if (this.accessTokenCompany) {
        UserModule.LogOutCompany(this.sid);
      }

      this.isErrors = false;
      await UserModule.LoginConsultant(this.login).catch(() => {
        this.isErrors = true;
      });

      this.login.username = '';
      this.login.password = '';

      if (this.isRedirectToCabinet) {
        await this.$router.push({
          name: 'Cabinet',
          query: { lang: this.lang },
        });
      } else {
        this.$bvModal.hide('login-modal');
      }
    } catch (error: any) {
      // this.$bvToast.toast(error.response.data.message, {
      //   title: 'Warning',
      //   variant: 'warning',
      //   autoHideDelay: 5000,
      //   solid: true,
      // });
    }
  }
}
</script>
